import { useEffect, useState } from 'react';

// Les barres fixées en bas de l'écran (lecteur audio, barre d'achat, bannière d'installation…) déclarent ici leur
// hauteur. La plus haute est publiée dans la variable CSS `--site-bottom-bar` : les boutons flottants du site
// (assistant) se placent au-dessus au lieu de recouvrir l'action principale de la barre.
const bars = new Map();
let nextId = 0;

const publish = () => {
  const h = Math.max(0, ...bars.values());
  document.documentElement.style.setProperty('--site-bottom-bar', `${Math.ceil(h)}px`);
};

/** Renvoie une ref de rappel à poser sur la barre : la réservation suit son montage, sa taille et son retrait. */
export function useReserveBottomSpace() {
  const [el, setEl] = useState(null);
  useEffect(() => {
    if (!el) return undefined;
    const id = nextId++;
    const measure = () => { bars.set(id, el.getBoundingClientRect().height); publish(); };
    measure();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    ro?.observe(el);
    return () => { ro?.disconnect(); bars.delete(id); publish(); };
  }, [el]);
  return setEl;
}
